module.exports = __webpack_public_path__ + "media/1_3-46.ff605c79.mp3";